import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../service/login.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-mail',
  templateUrl: './forgot-mail.component.html',
  styleUrls: ['./forgot-mail.component.scss']
})
export class ForgotMailComponent {
  public show: boolean = false;
  public numeroDocumento: number;
  public mail: string;
  mostrar: boolean = true;
  mostrarLoader: boolean = false;

  constructor(
    public router: Router,
    private authService: LoginService
  ) { }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

  onInputChange(event: any): void {
    const input = event.target.value;
    event.target.value = input.replace(/[^0-9]/g, '');
  }

  resetPassword() {
    if (!this.numeroDocumento) {
      Swal.fire({
        title: 'Campo incompleto',
        text: 'El campo Número de documento es obligatorio',
        icon: "info",
        confirmButtonText: 'Aceptar',
        customClass: {
          confirmButton: 'btn btn-primary btn-pills border-0'
        }
      });
      return;
    }
    this.mostrar = false;
    this.mostrarLoader = true;
    this.authService.forgotMail(this.numeroDocumento).subscribe((resp) => {
      if (resp.isSuccess) {
        this.mostrarLoader = false;
        this.router.navigateByUrl('login')
      } else {
        this.mostrar = true;
      }
    })
  }

}
